<div class="confirm-modal ig-modal share-trip-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>

    <div *ngIf="!isUserLoggedIn && data.type==='trip'">
        <mat-icon class="main-icon">share</mat-icon>
        <!--<h3>SHARE YOUR PLAN WITH FRIENDS!</h3>-->
        <p class="pdf-sub-tip">Please login before sharing trips with your friends.</p>

        <div class="fb-login-wrap space-around" [class.flex]="!isMobile">

            <ig-button fb (trigger)="FBLoggedIn($event)" size="md">LOGIN WITH FACEBOOK</ig-button>
<!--            <ig-button google (trigger)="GoogleLogin($event)" size="md">LOGIN WITH Google</ig-button>-->
            <div id="google-signin-btn-trip"></div>
        </div>
    </div>

     <div *ngIf="isUserLoggedIn||data.type==='tour'">
        <div>
            <div class="title">SHARE {{shareTitle}}</div>

            <div style="max-height:400px; overflow-y: auto;overflow-x: hidden;padding:3px;">

                <p class="tip">Email {{data.type==='trip'?'your trip':'the itinerary'}} URL:</p>

                <form ngForm="emailFormGroup">
                    <ig-field label="Ex: randy@go.com, aline@go.com"
                              [formControl]="emailFormGroup.get('shareToEmails')"
                              icon="mail_outline"
                              [(ngModel)]="shareToEmails">
                    </ig-field>
                </form>
                <ig-success-wrap #sendEmailsSuccess [text]="'Success!'">
                    <ig-button class="ig-blue-btn" style="width:88px" size="md" [isAsync]="true"
                               [disabled]="emailFormGroup.invalid" (trigger)="sendShareEmails($event)">send
                    </ig-button>
                </ig-success-wrap>

                <div class="tips m-t-3">Need a copy of your records or to edit your message?
                    <span class="link" (click)="shareByEmailApp()" role="button">Open email app</span>
                </div>
                <br/>
                <div class="tips">Share on Social Media:</div>
                <div class="share-icon-wrap">
                    <div tweet (click)="shareTweet()">
                        <div class="detail-share-icon detail-share-tweet" role="button" aria-label="share to tweet"><span class="hide-on-mobile">Tweet</span></div>
                    </div>
                    <div fb (click)="shareFacebook()">
                        <div wrap>
                            <div class="detail-share-icon" role="button" aria-label="share to facebook"><span class="detail-share-fb">f</span><span class="hide-on-mobile">Share</span></div>
                        </div>
                    </div>
                </div>


                <div class="title m-t-3">CONTACT US</div>

                <p class="tip" *ngIf="!isMobile">Didn’t find everything you were looking for? Traveling with a group or
                    need more information on one of the trip stops you selected? Not a problem, we’re here to help.
                    We’re always
                    happy to share tips and offer resources that can help you plan, pack and get ready to visit us.</p>
                <p class="tip" *ngIf="isMobile">Didn’t find everything you were looking for? Not a problem, send us your
                    questions and we’re happy to share tips and offer resources to help plan your trip.</p>

                <form ngForm="helpFormGroup">
                    <ig-row>
                        <ig-col [xs]="12" [md]="12">
                            <ig-row>
                                <ig-col [xs]="12" [md]="6">
                                    <ig-field label="Name"
                                              [required]="true"
                                              [formControl]="helpFormGroup.get('name')"
                                              icon="people"
                                              [(ngModel)]="help.name">
                                    </ig-field>
                                </ig-col>
                                <ig-col [xs]="12" [md]="6">
                                    <ig-field label="Phone Number"
                                              [formControl]="helpFormGroup.get('number')"
                                              icon="local_phone"
                                              type="number"
                                              [(ngModel)]="help.number">
                                    </ig-field>
                                </ig-col>
                            </ig-row>
                            <ig-row>
                                <ig-col [xs]="12">
                                    <ig-field label="Email"
                                              [formControl]="helpFormGroup.get('email')"
                                              icon="mail_outline"
                                              [(ngModel)]="help.email">
                                    </ig-field>
                                </ig-col>
                            </ig-row>
                            <ig-row>
                                <ig-col [xs]="12">
                            <textarea class="comments" matInput
                                      placeholder="Comments"
                                      [rows]="3"
                                      type="textArea"
                                      aria-label="comments"
                                      [(ngModel)]="help.comment"
                                      [formControl]="helpFormGroup.get('comment')">
                            </textarea>
                                </ig-col>
                            </ig-row>
                        </ig-col>
                        <ig-col [xs]="12" [md]="12" class="send-wrap">
                            <!--<span (click)="sendHelp()">Send Now</span>-->
                            <ig-success-wrap #sendHelpSuccess [text]="'Succeed'">
                                <ig-button class="ig-blue-btn" size="md" [isAsync]="true"
                                           [disabled]="helpFormGroup.invalid"
                                           (trigger)="sendHelp($event)">send
                                </ig-button>
                            </ig-success-wrap>
                        </ig-col>
                    </ig-row>
                </form>
            </div>

        </div>
    </div>

</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/trip/share.trip.modal/share.trip.modal.component.html